<template>
  <div>
    <div @click="navigateToAdminView()">
      <b-icon icon="chevron-left" class="mt-3"></b-icon>&nbsp;Zurück
    </div>

    <b-card header="Benutzer erstellen" class="mt-3">
      <b-form-group id="email">
        <label>E-Mail</label>
        <b-form-input
          v-model="email"
          type="email"
          placeholder="E-Mail eingeben..."
        ></b-form-input>
      </b-form-group>
      <b-form-group id="name" class="mt-3">
        <label>Vor- und Nachname</label>
        <b-form-input
          v-model="name"
          type="text"
          placeholder="Vor- und Nachname eingeben..."
        ></b-form-input>
      </b-form-group>
      <b-form-group id="roles" class="mt-3">
        <label>Benutzergruppe</label>
        <multiselect
          v-model="roles"
          :options="rolesOptions"
          :searchable="false"
          :multiple="true"
          :close-on-select="false"
          :show-labels="false"
          placeholder="Benutzergruppe auswählen..."
        ></multiselect>
      </b-form-group>
      <b-button variant="danger" class="mt-3" @click="createUser()"
        >Benutzer erstellen</b-button
      >
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
  name: "newUserView",
  components: { Multiselect },
  data() {
    return {
      email: null,
      name: null,
      roles: ["ROLE_USER"],

      rolesOptions: [
        "ROLE_USER",
        "ROLE_STUDENT",
        "ROLE_LICENSED_PILOT",
        "ROLE_FLIGHT_INSTRUCTOR",
        "ROLE_ADMIN",
      ],

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },
  methods: {
    navigateToAdminView() {
      this.$router.push(`/account/admin`);
    },

    createUser() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      const body = {
        email: this.email,
        name: this.name,
        roles: this.roles,
      };

      axios
        .post(this.apiUrl + "/account/admin/new-user", body)
        .then(async (response) => {
          Toast.fire({
            icon: "success",
            title: "Benutzer erstellt",
          });

          console.log(response.data);
          this.$router.push("/account/admin");
        });
    },
  },
};
</script>

<style scoped></style>
